import { DisplayTypeState } from './state';

export const DISPLAY_TYPE_LIST = 'list';
export const DISPLAY_TYPE_TILE = 'tile';
export const DISPLAY_TYPE_MINIMAL = 'minimal';

export const DISPLAY_TYPE_CHANGE = 'DISPLAY_TYPE_CHANGE';

export type DisplayTypeChange = {
    type: typeof DISPLAY_TYPE_CHANGE;
    payload: DisplayTypeState;
};

export type DisplayTypeAction = DisplayTypeChange;
